module.exports = __webpack_public_path__ + "static/sebrene-2c58de429f57b72a30e851a341c476a7.jpg";